
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/hospitality",
      function () {
        return require("private-next-pages/use-cases/hospitality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/hospitality"])
      });
    }
  